module.exports = __webpack_public_path__ + "static/contact-441b1ef7f8ed0180cf1c849c6545baac.jpeg";